import { render, staticRenderFns } from "./ModalCancelarBeneficio.vue?vue&type=template&id=44f6da80&scoped=true"
import script from "./ModalCancelarBeneficio.vue?vue&type=script&lang=js"
export * from "./ModalCancelarBeneficio.vue?vue&type=script&lang=js"
import style0 from "./ModalCancelarBeneficio.vue?vue&type=style&index=0&id=44f6da80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f6da80",
  null
  
)

export default component.exports